import React from 'react';
import { mediaMixin } from '@zillow/constellation';
import styled, { css } from 'styled-components';

const StyledErrorWrapper = styled.div`
    min-height: calc(100vh - 44px);
    text-align: left;

    > .content-wrapper {
        max-width: 1280px;
        margin-left: auto;
        margin-right: auto;
        padding: 20px;
    }

    display: block;
    flex-direction: column;
    justify-content: center;
    padding-top: 20px;

    ${mediaMixin(
        'md',
        css`
            min-height: calc(100vh + 1px - 50px);
        `
    )};
`;

interface ErrorWrapperProps {
    children: React.ReactNode;
}

const ErrorWrapper = ({ children }: ErrorWrapperProps) => (
    <StyledErrorWrapper>
        <main className="content-wrapper">{children}</main>
    </StyledErrorWrapper>
);

export default ErrorWrapper;
